"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllysService = void 0;
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
const axios_1 = __importDefault(require("axios"));
class AllysService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'allys';
        this.allysConnection = async (allys) => {
            //const URL = `${API_URL_BASE}/${this.ENV}/${this.RESOURCE}/allysconnect`;
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}`;
            const response = await axios_1.default.post(URL, JSON.stringify(allys), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getAlliesList = async () => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getShortcutsAllies = async (person_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/get-access-shortcuts`;
            const response = await axios_1.default.post(URL, JSON.stringify(person_id), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getNeoUserByEmail = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/neo/get-archived-status-by-student`;
            const response = await axios_1.default.post(URL, JSON.stringify(user), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getNeoCoursesByUser = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/neo/get-courses-by-student-id-and-ou`;
            const response = await axios_1.default.post(URL, JSON.stringify(user), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.validateNeoUser = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/neo/validate-user`;
            const response = await axios_1.default.post(URL, JSON.stringify(user), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.AllysService = AllysService;
